import { Route, Routes } from "react-router-dom";
import storage from "../../helpers/storage";
import { AllUser } from "./List/List";

export const User = () => {
  storage.setPageTitle("Users");
  return (
    <Routes>
      <Route path="/" element={<AllUser />} />
    </Routes>
  );
};
